import Tippy from '@tippyjs/react';

import Icon from '../Icon/Icon';
import Typography from '../Typography/Typography';

export const CaptionDesktop = ({ caption, info, size = 'xs' }) => {
  return (
    <div className="flex items-center gap-1">
      {caption && (
        <Typography
          variant="p"
          size={size}
          color="neutral-700"
          weight="medium"
          className="cursor-pointer leading-4">
          {caption}
        </Typography>
      )}
      {info && (
        <Tippy content={info} className="tippy-dark">
          <div className="flex h-5 w-5 items-center justify-center hover:rounded-sm hover:bg-neutral-75">
            <Icon icon="info-mono" size={14} />
          </div>
        </Tippy>
      )}
    </div>
  );
};

export const CaptionMobile = ({ info, size = 'xs' }) => {
  if (!info) return null;

  return (
    <div className="flex flex-col items-center gap-1">
      <Typography
        variant="p"
        size={size}
        color="neutral-700"
        weight="medium"
        className="cursor-pointer leading-4">
        {info}
      </Typography>
    </div>
  );
};
